const patchResizeObserver = () => {
  if (typeof window === 'undefined' || !window.ResizeObserver) return;

  const original = window.ResizeObserver;
  
  window.ResizeObserver = class extends original {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try {
            if (entries.some(entry => entry.target.isConnected)) {
              callback(entries, observer);
            }
          } catch (e) {
            if (!e.message.includes('ResizeObserver')) {
              console.error('ResizeObserver error:', e);
            }
          }
        });
      });
    }
  };
};

export default patchResizeObserver;